var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#775A9B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 7,
    width: 24,
    height: 24,
    fill: "url(#pattern0_439_2552)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_439_2552",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_439_2552",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_439_2552",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgEAQAAACJ4248AAAAIGNIUk0AAHomAACAhAAA+gAAAIDoAAB1MAAA6mAAADqYAAAXcJy6UTwAAAACYktHRAAAqo0jMgAAAAlwSFlzAAAAYAAAAGAA8GtCzwAAAAd0SU1FB+cIGw0rM7GFFekAAAIOSURBVFjD5Zc9SytBGIXPWbVSEK3T+BELMSAxYCws/AErCEYt7Kxs/QdiYecfsLTShVhYiqQVwZDCys9COz8LrWTn3GKJG4nX7Izr5aKn2Z1h5j3Pzjs7+y7w28Ukg6TeXmB8HOrqcncKQ+jkhN7pqdU8mclJ6eFBqcgYaXXVDkC1WjrmDRAmm63Hb2+NMDISkRweAhsbzilAsQiurAAkmMsBZ2cJAdraouv1Nb0gcLWXaWzUYwKe+xOlo58JIPX1yWxuyvh+q7Hv9oBMoQBK5PGxs7kZHAQqFTCTAWZngZ6eRADS2BhwdBTdFwpktepkzkoFyGSinr29VnPiFKi/HyABEhoY+NzI96WnJ2lrS6aj42Pz3V1oaSk5gJV8H+juBhYXwe1taXi42Xx+nt7r6/cAcH0duLmJGjMzQK3mYu4MQF5dQVNTMUSUBqhctjF3XwEA9M7P30GoXAYWFmzMgURH8ecQMvk8MDoKHhyQxtjG+BJABHF7C+zvu87/mUexjVqnQC8vYGcnODEhs7Pj7MT6awqAz8/NPqZUiouWUumtX0GQbkV0fy/F34fWKdDyMhQEwAfUVgpDoFoFpqfJx8fEKaB3dwfMzX3N/O/6jzYhwzDuLhZlfaTU41xeOtUTMkNDUd2eRu2fzyf1fUtB9MeytgZI/2Dl4wVrXolsFszlGktnu4gXFy7V1O/VH8JQBFen75hIAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleCheck);
export default __webpack_public_path__ + "static/media/double-check.05d4576d65ea89d818b05f652c4625ca.svg";
export { ForwardRef as ReactComponent };